/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TrackingContext } from '@vrbo/react-event-tracking';
import Input from '@ferris/react/components/forms/Input';
import SubmitButton from '../../Button/SubmitButton';
import CompetitorLink from './CompetitorLink';
import { VrboCtx } from '../../../contexts/vrbo';
import { ESTIMATE_PAGE } from '../../PageFlow/PageList';

const pageName = ESTIMATE_PAGE;

const EstimateCta = (props) => {
    const {
        callCreateProperty,
        setCompetitorLinkValue,
        loading
    } = useContext(VrboCtx);

    const {
        estimateButtonLabel
    } = props;

    const { trigger } = useContext(TrackingContext);


    const handleClick = () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'EstimateResults: nextButton'
        });
        callCreateProperty(pageName);
    };

    const { competitorLink } = props;

    const competitorLinkOnChange = (e) => {
        setCompetitorLinkValue(e.target.value.trim());
    };

    const competitorLinkField = (
        <Input
            onChange={competitorLinkOnChange}
            floatLabel
            label={competitorLink.fieldLabel}
            disabled={loading}
        />
    );

    return (
        <>
            <CompetitorLink
                {
                ...{
                    ...competitorLink,
                    field: competitorLinkField
                }
                }
            />
            <SubmitButton data-wdio="next-button" animated={loading} label={estimateButtonLabel} disabled={loading} onClick={handleClick} />
        </>
    );
};

EstimateCta.propTypes = {
    estimateButtonLabel: PropTypes.string.isRequired,
    competitorLink: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        fieldLabel: PropTypes.string,
        display: PropTypes.bool.isRequired
    }).isRequired
};

export default EstimateCta;
